export const formatValue = (value: any): string => {
  if (value === null || value === undefined) {
    return '-'
  }
  if (!isNaN(value as number)) {
    if (value < 0.01) {
      return value.toExponential(3)
    }
    return value.toFixed(3)
  }
  return value.toString()
}
